var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-table",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.896,
    height: 20.909,
    viewBox: "0 0 23.896 20.909",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "table-solid",
    d: "M21.655,32H2.24A2.24,2.24,0,0,0,0,34.24V50.668a2.24,2.24,0,0,0,2.24,2.24H21.655a2.24,2.24,0,0,0,2.24-2.24V34.24A2.24,2.24,0,0,0,21.655,32Zm-11.2,17.922H2.987v-4.48h7.467Zm0-7.467H2.987v-4.48h7.467Zm10.454,7.467H13.441v-4.48h7.467Zm0-7.467H13.441v-4.48h7.467Z",
    transform: "translate(0 -32)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTable);
export default __webpack_public_path__ + "static/media/ic-table.5495b3021178cb28064228288d5c1f8b.svg";
export { ForwardRef as ReactComponent };